const KOZYCLANLOGO  = require('../assets/images/logo.png');
const KOZYCLANLOGOWHITE  = require('../assets/images/logo-white.png');
const FLAG_ICON  = require('../assets/images/flag-icon.png');
const TripCoverImage = require('../assets/images/TripCoverImage.png');
const TripImage = require('../assets/images/TripImage.png');
const TripSlotImage = require('../assets/images/TripSlotImage.png');
const TripSlotTierImage = require('../assets/images/TripSlotTierImage.png');
const ProfileImage = require('../assets/images/AppProfileImage.png');
export {
    KOZYCLANLOGO,
    KOZYCLANLOGOWHITE,
    FLAG_ICON,
    TripCoverImage,
    TripImage,
    TripSlotImage,
    TripSlotTierImage,
    ProfileImage
}